import { Stack, Typography } from "@mui/material";
import DialogConfirmation from "components/general/DialogConfirmation";
import { useTranslation } from "react-i18next";
import { DeleteEmailTemplateDialogProps } from "./DeleteEmailTemplateDialog.type";

export function DeleteEmailTemplateDialog({
  template,
  isDeleting,
  onConfirm,
  onClose,
}: DeleteEmailTemplateDialogProps) {
  const { t } = useTranslation("emailing");

  const handleConfirm = () => {
    if (template) {
      onConfirm(template);
    }
  };

  return (
    <DialogConfirmation
      open={!!template}
      isLoading={isDeleting}
      cancelTextButton={t("modalDelete.cancel")}
      submitTextButton={t("modalDelete.confirm")}
      title={t("modalDelete.title", { name: template?.name })}
      description=""
      setOpen={onClose}
      handleSubmit={handleConfirm}
    >
      <Stack spacing={2} pt={2}>
        <Typography>
          {t("modalDelete.desc")}
          {template?.name}
        </Typography>

        <Typography>{t("modalDelete.desc2")}</Typography>
      </Stack>
    </DialogConfirmation>
  );
}
